import React, { useContext } from "react";
import "./sideBar.scss";
import { IoSettingsOutline } from "react-icons/io5";
import { MdOutlineLogout } from "react-icons/md";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";


const SideBar = () => {
  const navigate = useNavigate();
  const { admin, dispatch } = useContext(AuthContext);

  const user = admin.role === "admin";

  const logoutUser = async () => {
    const controller = new AbortController();
    const signal = controller.signal;
    try {
      await axios.get("/admin-logout");
      localStorage.removeItem("admin");
      dispatch({ type: "LOGOUT" });
      navigate("/");
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request canceled", error.message);
      } else {
        console.error("Error fetching data:", error);
      }
    }
    return () => controller.abort();
  };
  return (
    <div className="sideBar_wrp">
      <div className="sideBar_in">
        <Link to={"/event"}>
          <div className="sideBar_top">
            <img src={require("../../img/logo.webp")} alt="" />
          </div>
        </Link>
        <div className="sideBar_center">
          <ul>
            <NavLink
              to="/event"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <li>
                <small>Events</small>
              </li>
            </NavLink>

            <NavLink
              to="/dashboard"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <li>
                <small>All</small>
              </li>
            </NavLink>
          </ul>
        </div>
        <div className="sideBar_bottom">
          <span onClick={logoutUser}>
            <MdOutlineLogout fontSize={20} />
            <small>Logout</small>
          </span>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
